import React, { Component } from 'react';
import { Button, Table, Popconfirm, Input, message, Select, Tag, Row, Col, Card, DatePicker, Tooltip, Typography, Divider, Badge } from 'antd'

import {
    PlusOutlined,
    MinusOutlined,
    ReloadOutlined,
    SendOutlined,
    PrinterOutlined,
    CloseOutlined,
    LikeTwoTone,
    DislikeTwoTone,
    QuestionCircleOutlined,

} from '@ant-design/icons';


import ReactToPrint from "react-to-print";

import { inject, observer } from 'mobx-react';

import _ from 'lodash';
import moment from 'moment';
import NavbarPanel from '../components/NavbarPanel';
import { LoadingGlobal } from '../components/LoadingGlobal';
//moment.locale('tr')
//import 'moment/locale/tr';

//Yazdırnma
import ComponentToPrint from '../components/ToPrint'
import { toJS } from 'mobx';
import { date2DD, formatMyMoney, tarihToYYYYMMDD } from '../helper';
import { Link } from 'react-router-dom';


const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;


@inject('HourseBetStore', 'UserStore')
@observer
export default class Coupon extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modalVisible: false,
            couponcode: '',
            user: 'all',
            start: new Date(),
            end: new Date(),
            ctype: 'all',
            status: 'all',
            expandedRowKeys: []
        }

    }

    componentDidMount() {
        //kullanıcıları da set et 
        this.props.UserStore.getUsers();
        const data = _.get(this.props, "HourseBetStore.coupons", [])
        if (data.length == 0) {
            this.getItemList();
        }

        window.scrollTo(0, 0)
    }

    getItemList = async (obj) => {
        const { couponcode, user, start, end, ctype, status } = this.state

        const action = _.get(obj, "action")

        let filtered = {
            couponcode,
            user,
            start: new Date(start).setHours(0, 0),
            end: new Date(end).setHours(24, 59),
            ctype,
            status,
            action
        }

        try {
            let serverData = await this.props.HourseBetStore.listCoupon(filtered);
            console.log({ serverData })
            if (serverData.length > 0) {
                console.log({ aaaaaaaaaaaaaaaaa: serverData[0]._id })
                //  [serverData.length > 0 ? data[0]._id : null]
                this.setState({
                    expandedRowKeys: [serverData[0]._id]
                })
            }
        } catch (error) {
            console.log(error)
        }
        finally {
            // this.setState({ loading: false })
        }

    }

    onChangeSelect = (e, type) => {

        this.setState({
            [type]: e
        }, () => {
            this.getItemList()
        })

    }

    resetState = () => {
        this.setState({
            couponcode: '',
            user: 'all',
            start: new Date(),
            end: new Date(),
            ctype: 'all',
            status: 'all',
        }, () => {
            this.getItemList()
        })
    }


    onChangeDatePicker = (dates, dateStrings, type) => {
        // dateStrings
        console.log({ dates, dateStrings, dd: new Date(dates) })


        if (!dates) {
            this.setState({
                [type]: new Date()
            }, () => {
                this.getItemList()
            })
        }
        else {
            this.setState({
                [type]: new Date(dates)
            }, () => {
                this.getItemList()
            })
        }



    }

    onClickCancel = (record) => {
        //   const record = item.runs[0]
        if (date2DD({ TARIH: record.runs[0].TARIH, SAAT: record.runs[0].SAAT, setMinute: true }) <= new Date()) {
            message.warn("Başlamış koşu iptal edilemez!")
            return
        }
        this.onCancelService(record)
    }


    onCancelService = async (data) => {
        this.setState({ loading: true })
        try {
            const serverData = await this.props.HourseBetStore.remove(data)
            const newBalance = _.get(serverData, "newBalance", 0)
            const id = _.get(serverData, "_id")
            this.props.UserStore.setUserBalance(newBalance)

            this.props.HourseBetStore.splice(id)

            console.log("onCancelService", { serverData })
            message.success()
        } catch (error) {
            console.log({ error })
        }
        finally {
            this.setState({ loading: false })
        }
    }

    onBeforePrint = (item) => {
        console.log("onBeforePrint", item)
        //  this.setState({ ...item })
    }
    onAfterPrint = () => {
        console.log("onAfterPrint")
    }


    render() {
        //değişkenler vs

        const loading = _.get(this.props, "HourseBetStore.loading", false)
        const data = _.get(this.props, "HourseBetStore.coupons", [])

        const avaiableBahisler = _.get(this.props, "HourseBetStore.avaiableBahisler", [])
        const couponTypes = _.get(this.props, "HourseBetStore.couponTypes", [])

        const { users } = this.props.UserStore
        const { user } = this.props.UserStore

        const dateFormat = 'DD/MM/YYYY';
        const dateFormatTime = 'DD/MM/YYYY HH:mm';

        const columns = [

            { title: 'Kupon No', dataIndex: 'couponno', key: 'couponno' },
            {
                title: 'Zaman',
                key: 'date',
                render: (text, record) =>
                    <span>
                        <Tooltip
                            title={moment(record.created).fromNow()}>
                            {moment(record.created).format(dateFormatTime)}
                        </Tooltip>
                    </span>
            },
            {
                title: 'Kullanıcı',
                key: 'user',
                render: (text, record) =>
                    <span>
                        {_.get(record, "user.username")}
                    </span>

            },
            {
                title: 'Açıklama',
                key: 'detail',
                render: (text, record) =>
                    <span>
                        <Text type="secondary">
                            {record.text}
                        </Text>
                        /
                        {_.get(record, "selectedBahis.text", "")}
                        /
                        {_.get(record, "selectedBahis.children.text", "")}
                    </span>
            },
            {
                title: 'Oran',
                key: 'betCount',
                dataIndex: 'betCount'
            },
            {
                title: 'Misli',
                key: 'much',
                dataIndex: 'much'
            },
            {
                title: 'Tutar',
                key: 'price',
                render: (text, record) =>
                    <span>
                        <b>  {record.priceFormated} ₺</b>
                    </span>
            },
            {
                title: 'Durum',
                key: 'state',
                render: (text, record) =>
                    <div style={{ textAlign: 'center' }}>
                        {
                            record.status == 2
                            && <QuestionCircleOutlined style={{ fontSize: 28 }} title="Bekleniyor" />
                        }
                        {
                            record.status == 1
                            && <span style={{ color: 'green' }}>

                                <b>
                                    {
                                        formatMyMoney(record.gainPrice)

                                    }
                                ₺
                                {` `}
                                </b>

                                {
                                    // <LikeTwoTone twoToneColor="green" style={{ fontSize: 24 }} title="Kazandı" />
                                }
                            </span>
                        }
                        {
                            record.status == 0
                            &&
                            <CloseOutlined style={{ fontSize: 18, color: 'red' }} title="Kaybetti" />

                            //<DislikeTwoTone twoToneColor="red" style={{ fontSize: 24 }} title="Kaybetti" />
                        }
                    </div>
            },
            {
                title: '',
                key: 'action',
                render: (text, record) =>
                    <span>
                        {
                            (
                                date2DD({ TARIH: record.runs[0].TARIH, SAAT: record.runs[0].SAAT, setMinute: true })
                                >
                                new Date()
                            )
                            &&

                            <Popconfirm okText="Evet" cancelText="Hayır" title={`Emin misiniz?`}
                                onConfirm={() => { this.onClickCancel(record) }}>
                                <Button type="danger" size="small">
                                    İptal Et
                        </Button>
                            </Popconfirm>


                        }

                        <Divider type="vertical" />

                        <ReactToPrint
                            onBeforePrint={() => this.onBeforePrint(record)}
                            onAfterPrint={(e) => this.onAfterPrint(e)}
                            trigger={() => {
                                return <Button
                                    onMouseOver={() => this.setState({ coupon: record })}
                                    size="small" type="primary" title="Yazdır"
                                    icon={<PrinterOutlined />} />
                            }}
                            content={() => this.componentRef}

                        >
                        </ReactToPrint>
                    </span>
            },
        ];




        return (
            <div>
                <NavbarPanel page="coupon" />
                <LoadingGlobal loading={loading} />

                <div style={{ backgroundColor: '#FFF', padding: '24px' }}>
                    <Row>
                        <Col span={24}>
                            <span>
                                Kuponlar
                                {` `}
                                <Text type="secondary">
                                    ( {data.length} )
                                </Text>
                                {` `}
                                <Button
                                    size="small"
                                    title="Yenile"
                                    type='ghost'
                                    shape='circle-outline'
                                    icon={<ReloadOutlined />}
                                    onClick={() => this.resetState()}
                                />
                            </span>
                        </Col>
                    </Row>
                    <Row style={{ backgroundColor: '#fff', fontWeight: 'normal', fontSize: 12 }} >
                        <Col span={4} className={"pr-10"}>
                            <p className={"mb-0"}>
                                Kupon No</p>
                            <Input
                                onPressEnter={() => this.getItemList({ action: "couponcode" })}
                                type="text"
                                onChange={(e) => this.setState({ couponcode: e.target.value })}
                                value={this.state.couponcode}
                                suffix={<span>
                                    {
                                        this.state.couponcode
                                        &&
                                        <span>

                                            {` `}
                                            <Button
                                                size="small"
                                                type="danger"
                                                onClick={() => this.setState({ couponcode: '' }, () => {
                                                    this.getItemList()
                                                })} icon={<CloseOutlined />} />
                                            <Button
                                                size="small"
                                                type='ghost'
                                                icon={<SendOutlined />}
                                                onClick={() => this.getItemList({ action: "couponcode" })}
                                            />
                                        </span>

                                    }

                                </span>} />



                        </Col>
                        {
                            _.get(user, "userType", 4) != 4
                            &&
                            <Col span={4} className={"pr-10"}>
                                <p className={"mb-0"}>
                                    Kullanıcı</p>
                                <Select className={"w100"} value={this.state.user} onChange={(e) => this.onChangeSelect(e, "user")} >
                                    <Option value={"all"}>Tümü</Option>
                                    {
                                        users.map((v, i) => {
                                            return (
                                                <Option key={i} value={v._id}>{v.username}</Option>
                                            )
                                        })
                                    }
                                </Select>

                            </Col>
                        }
                        <Col span={4} className={"pr-10"}>
                            <p className={"mb-0"}>
                                İlk Tarih</p>
                            <DatePicker
                                value={moment(this.state.start, dateFormat)}
                                format={dateFormat}
                                onChange={(v, dateString) => this.onChangeDatePicker(v, dateString, "start")}
                                className={"w100"}
                            />
                        </Col>
                        <Col span={4} className={"pr-10"}>
                            <p className={"mb-0"}>
                                Son Tarih</p>
                            <DatePicker
                                value={moment(this.state.end, dateFormat, "end")}
                                onChange={(v, dateString) => this.onChangeDatePicker(v, dateString, "end")}
                                format={dateFormat}
                                className={"w100"} />
                        </Col>
                        <Col span={4} className={"pr-10"}>
                            <p className={"mb-0"}>
                                Kupon Tipi</p>
                            <Select className={"w100"} value={this.state.ctype} onChange={(e) => this.onChangeSelect(e, "ctype")} >
                                <Option value={"all"} >Tümü</Option>
                                {
                                    avaiableBahisler.map((v, i) => {
                                        return (
                                            <Option key={i} value={v.value}>{v.text}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={4}>
                            <p className={"mb-0"}>
                                Durum</p>
                            <Select className={"w100"} value={this.state.status} onChange={(e) => this.onChangeSelect(e, "status")} >
                                <Option value={"all"} >Tümü</Option>
                                {
                                    couponTypes.map((v, i) => {
                                        return (
                                            <Option key={i} value={v.value}>{v.text}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                </div>


                <Card
                    bordered={false}
                >
                    <Table
                        size='small'
                        bordered={true}
                        rowKey={'_id'}
                        loading={loading}
                        columns={columns}
                        pagination={false}
                        //pagination={{ pageSize: 100 }}
                        dataSource={data}
                        expandedRowRender={(record, i) =>
                            <span>
                                <Row>
                                    <Col span={24}>
                                        <table style={{ backgroundColor: "rgba(255,213,213,1)", padding: 5, borderRadius: 10 }} >
                                            <thead>
                                                <tr>
                                                    <th>Koşu No</th>
                                                    <th>Atlar</th>
                                                    <th>Sonuç</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    _.get(record, "runs", []).map((v, i) => {
                                                        return (
                                                            <tr key={i} style={{ backgroundColor: i % 2 == 0 ? "rgba(0,0,0,0.1)" : undefined }}>
                                                                <td style={{ padding: 10 }}>
                                                                    {i + 1}
                                                                </td>
                                                                <td style={{ padding: 10 }}>
                                                                    {
                                                                        _.get(v, "atlar", []).map((v, i) => {
                                                                            return (
                                                                                <span key={i}>
                                                                                    <Tag
                                                                                        color={v.SONUC == "1" ? "success" : undefined}
                                                                                        title={v.AD}>
                                                                                        <b>{v.NO}</b> - {v.AD}
                                                                                        {
                                                                                            v.SONUC &&
                                                                                            <span>({v.SONUC})</span>
                                                                                        }
                                                                                    </Tag>
                                                                                </span>
                                                                            )
                                                                        })
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        v.completed
                                                                        &&


                                                                        <Link
                                                                            to={`/panel/result?KEY=${record.value}&date=${tarihToYYYYMMDD({ TARIH: v.TARIH })}&run=${v.NO}`}
                                                                        >
                                                                            Görüntüle
                                                                    </Link>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            </span>
                        }
                        expandRowByClick={true}
                        //  defaultExpandAllRows={true}
                        //  expandedRowKeys={[data.length > 0 ? data[0]._id : null]}
                        // expandedRowKeys={['5fae8053703c44385ca0b317']}
                        expandedRowKeys={this.state.expandedRowKeys}
                        onExpandedRowsChange={(expandedRowKeys) => this.setState({ expandedRowKeys })}
                    />

                </Card>

                <div style={{ display: "none" }}>
                    <ComponentToPrint type="coupon" state={this.state.coupon} ref={el => (this.componentRef = el)} />
                </div>

            </div>
        )
    }
}